<eds-panel
  [enableHover]="false"
  [hasBorderRadius]="false"
  [hasBorders]="true"
  [hasPadding]="true"
  [hasShadows]="false"
  edsBackground
  theme="white"
>
  <eds-proximal placement="DistributionSchedulesProximalTop"></eds-proximal>

  <div edsGrid>
    <div edsRow>
      <div edsCol>
        <eds-section-header
          [isLight]="true"
          size="h6"
          [title]="'products.distribution-schedules-title' | translate"
          [level]="3"
          edsSpacing="md"
          theme="primary"
          caveatPlacement="Distribution:SchedulesSection"
        ></eds-section-header>
      </div>
    </div>

    <div edsRow>
      <div edsCol>
        <eds-info-item
          [info]="getInfoItemData('dividend')"
          edsSpacing="xs"
        ></eds-info-item>
        <eds-info-item
          *ngIf="schedules?.capgainFrequency"
          [info]="getInfoItemData('capgains')"
          edsSpacing="xs"
        ></eds-info-item>
      </div>
    </div>
  </div>

  <eds-proximal placement="DistributionSchedulesProximalBottom"></eds-proximal>
</eds-panel>
